import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

class ContributorSettingsAppBar extends Component {

  render() {
    return(
      <Tabs value="contributors" variant="scrollable">
        <Tab style={{minHeight:'72px'}} label="Contributors" value='contributors' component={Link} to="/contributor-settings" />
      </Tabs>
    )
  }
}

const mapStateToProps = (state) => ({ isMultiUserMindfile: state.mindfile.group })

export default connect(mapStateToProps)(ContributorSettingsAppBar)
